module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "inline-block"
  }, [_c('div', {
    staticClass: "button",
    class: _vm.myIsPlay ? 'play' : 'pause',
    attrs: {
      "id": _vm.id
    },
    on: {
      "click": _vm.player
    }
  }, [_c('audio', {
    attrs: {
      "src": _vm.src,
      "preload": "auto"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2dfe9f0b","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/player/audio.vue
// module id = 1174
// module chunks = 1